module.exports = __webpack_public_path__ + "img/广藿香.68d96f93.jpg";